import Icon from '@/components/Icon';
import styles from './NavItem.module.css';
import { Link, useNavigate } from 'react-router-dom';
import Badge from '../layout/Badge';

const NavLink = ({ path, children }: any) => {
  const navigate = useNavigate();

  if (path.indexOf('http') === 0) {
    return (
      <a href={path} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }

  return (
    <Link
      to={path}
    // onMouseUp={e => {
    //   e.preventDefault();
    //   navigate(path);
    //   return false;
    // }}
    >
      {children}
    </Link>
  );
};

const NavItem = ({ value, selected, badge, alerta }: any) => {
  return (
    <li
      className={[
        styles.container,
        value.important ? styles.emphasis : null,
      ].join(' ')}
    >
      <NavLink path={value?.path}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            padding: value.important ? '8px' : 0,
            borderRadius: '8px',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          {alerta ? (
            <span className="notif notif-danger" title={alerta}>
              <Icon path={value.icon} size={value.important ? 1.2 : 0.8} color="var(--tc-color-danger)" />
            </span>
          ) : (
            <Icon
              path={value.icon}
              size={value.important ? 1.2 : 0.8}
              color="var(--tc-color-brand-primary)"
            />
          )}
          <span className="link_name">{value.label}</span>
          {badge !== undefined && badge > 0 && (
            <Badge
              variant='danger'
              style={{
                marginLeft: 'auto',
                fontSize: '0.75rem',
                fontWeight: 'bold',
              }}
            >
              {badge}
            </Badge>
          )}
        </div>
      </NavLink>
    </li>
  );
};

export default NavItem;
